<div class="flex">
  <input
    maxlength="500"
    panInput
    color="primary"
    class="flex-1 !rounded-none !border-none focus:ring-0"
    (keyup.enter)="submitComment()"
    placeholder="Enter comment here..."
    [(ngModel)]="comment"
  />

  <app-pan-button
    color="primary"
    icon="send"
    class="!rounded-none my-[-1px]"
    (click)="submitComment()"
    [disabled]="!canSubmitComment()"
  ></app-pan-button>
</div>
